import { render, staticRenderFns } from "./TrToolboxColor.vue?vue&type=template&id=1d8a9ac3&scoped=true&"
import script from "./TrToolboxColor.vue?vue&type=script&lang=js&"
export * from "./TrToolboxColor.vue?vue&type=script&lang=js&"
import style0 from "./TrToolboxColor.vue?vue&type=style&index=0&id=1d8a9ac3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a9ac3",
  null
  
)

export default component.exports